/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingHomeIcon16Solid = forwardRef('BuildingHomeIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.232 1.768.707 7.293C.077 7.923.523 9 1.414 9H3v3.5A2.5 2.5 0 0 0 5.5 15h5a2.5 2.5 0 0 0 2.5-2.5V9h1.586c.89 0 1.337-1.077.707-1.707L9.768 1.768a2.5 2.5 0 0 0-3.536 0Z" })));
});
